export function stringInject(str, arr) {
  if (typeof str !== "string" || !Array.isArray(arr)) {
    return "";
  }

  return str.replace(/({\d})/g, (i) => {
    return arr[i.replace(/{/, "").replace(/}/, "")];
  });
}

export function capitalize(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}
